import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "transportation-ticket-card" }
const _hoisted_2 = { class: "transportation-ticket-card__header d-flex justify-content-between" }
const _hoisted_3 = { class: "transportation-ticket-card__header__first-text" }
const _hoisted_4 = { class: "transportation-ticket-card__content d-flex flex-column justify-content-center" }
const _hoisted_5 = { class: "transportation-ticket-card__content__travel-where" }
const _hoisted_6 = { class: "transportation-ticket-card__content__date" }
const _hoisted_7 = { class: "transportation-ticket-card__footer d-flex justify-content-between" }
const _hoisted_8 = { class: "transportation-ticket-card__footer__time" }
const _hoisted_9 = { class: "transportation-ticket-card__footer__cost" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.ticketTitle)), 1),
      _createElementVNode("div", {
        class: "transportation-ticket-card__header__second-text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack($event, _ctx.routeString)))
      }, _toDisplayString(_ctx.$t('change_ticket')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.transportation.pickup_city.address_to_show) + " - " + _toDisplayString(_ctx.transportation.dropoff_city.address_to_show), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.dateHelpers.dateToDisplay(_ctx.tripDate)), 1)
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "transportation-ticket-card__line" }, null, -1)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.transportation.pickup_time) + " - " + _toDisplayString(_ctx.transportation.drop_off_time), 1),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.transportation.totals.tax_total) + " " + _toDisplayString(_ctx.$t('symbol_eur')), 1)
    ])
  ]))
}